import { FEATURE_FLAGS } from "@constants";
import { RootState } from "@redux/store";
import { useEffect } from "react";
import { useSelector } from "react-redux";

declare global {
  interface Window {
    pylon?: {
      chat_settings?: {
        app_id: string;
        email?: string;
        name?: string;
        avatar_url?: string;
        email_hash?: string;
      };
    };
    Pylon?: (...args: unknown[]) => void;
  }
}

const usePylonChat = () => {
  const currentUser = useSelector((state: RootState) => state.profiles.currentUser);

  useEffect(() => {
    if (!FEATURE_FLAGS.PYLON_CHAT) return;
    if (!gon.pylon_app_id) return;
    if (!currentUser.id) return;

    window.pylon = {
      chat_settings: {
        app_id: gon.pylon_app_id,
        email: currentUser.email,
        name: currentUser.name,
        avatar_url: currentUser.image?.medium?.url ?? undefined,
        email_hash: gon.pylon_email_hash,
      },
    };
  }, [currentUser.id, currentUser.email, currentUser.name, currentUser.image?.medium?.url]);
};

export default usePylonChat;
